import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsTransformationsTransformationId } from "@dashboardApi/apis/dataTransformation/constants";
import type {
  GenerateTransformationRequest,
  GenerateTransformationResponse,
} from "@dashboardApi/apis/dataTransformation/types";
import fetch from "@lib/fetch";

// TODO(OPR-978): Remove this legacy AI-copilot fetcher and the /generate backend endpoint. The
// dashboard no longer calls it now that the AI copilot has been fully replaced by Operator.
export const generateTransformation = reactQueryMutationAdapter(
  appsTransformationsTransformationId,
  async (request: GenerateTransformationRequest): Promise<GenerateTransformationResponse> => {
    return fetch(
      `/apps/transformations/${request.transformation_id}/generate`,
      "POST",
      request,
      {},
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
